import React, { FC } from 'react';
import './index.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: any;
}

const Modal = React.forwardRef<HTMLDivElement, ModalProps>(function Modal(
  { isOpen, onClose, children },
  ref
) {
  return (
    isOpen && (
      <div id='modal-backdrop' ref={ref}>
        <dialog className='modal-content'>
          <button
            id='modal-close-button'
            className='modal-close-button'
            onClick={onClose}
          >
            <span></span>
            <span></span>
          </button>
          {children}
        </dialog>
      </div>
    )
  );
});

export default Modal;
